// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3104 ? "3975359d" : chunkId) + "." + {"2242":"11d84f9730e90e3d","3104":"4215c998fccbfbb9"}[chunkId] + ".js";
};